// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

type SvgProps = {
    width?: number;
    height?: number;
}

const ComplianceExportSVG = (props: SvgProps) => (
    <svg
        width={props.width ? props.width.toString() : '189'}
        height={props.height ? props.height.toString() : '116'}
        viewBox='0 0 186 116'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
    >
        <g clipPath='url(#clip0_4441_159184)'>
            <rect
                x='0.745117'
                y='17'
                width='181'
                height='78'
                rx='5.625'
                fill='var(--center-channel-color)'
                fillOpacity='0.12'
            />
            <path
                d='M9.5 30L15 35.5V74.5H172.5V103.5'
                stroke='var(--center-channel-color)'
                strokeLinecap='round'
            />
            <circle
                cx='2.5'
                cy='2.5'
                r='2.5'
                transform='matrix(1 0 0 -1 170 107)'
                fill='var(--center-channel-color)'
            />
            <circle
                cx='2.5'
                cy='2.5'
                r='2.5'
                transform='matrix(1 0 0 -1 6 31)'
                fill='var(--center-channel-color)'
            />
            <rect
                x='25'
                y='11'
                width='131'
                height='86'
                rx='4'
                fill='var(--center-channel-bg)'
                stroke='var(--center-channel-color)'
                strokeWidth='4'
            />
            <rect
                x='29'
                y='15'
                width='46'
                height='78'
                fill='var(--button-bg)'
                fillOpacity='0.16'
            />
            <path
                d='M44.8109 22.0273L61.5002 22.0273'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <path
                d='M44.8109 24.6628L54.4732 24.6628'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <path
                d='M33.392 33.4453H46.5678'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <circle
                cx='36.5092'
                cy='22.5105'
                r='4.34771'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <circle
                cx='34.4795'
                cy='38.1602'
                r='2'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M40.4189 38.1602H65.0137'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <circle
                cx='34.4795'
                cy='45.1602'
                r='2'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M40.4189 45.1602H59.7434'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <circle
                cx='34.4795'
                cy='53.1602'
                r='2'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M40.4189 53.1602H67.6489'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <circle
                cx='34.4795'
                cy='60.1602'
                r='2'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M40.4189 60.1602H65.0137'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <circle
                cx='34.4795'
                cy='67.1602'
                r='2'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M40.4189 67.1602H59.7434'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <circle
                cx='34.4795'
                cy='74.1602'
                r='2'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M40.4189 74.1602H67.6489'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.32'
                strokeLinecap='round'
            />
            <path
                d='M145 103.5H117.5'
                stroke='var(--center-channel-color)'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M114 103.5H108'
                stroke='var(--center-channel-color)'
                strokeLinecap='round'
            />
            <path
                d='M105 103.5H99'
                stroke='var(--center-channel-color)'
                strokeLinecap='round'
            />
            <path
                d='M158.5 61C174.24 61 187 48.2401 187 32.5C187 16.7599 174.24 4 158.5 4C142.76 4 130 16.7599 130 32.5C130 48.2401 142.76 61 158.5 61Z'
                fill='var(--neutral-1200)'
                fillOpacity='0.24'
            />
            <path
                d='M158.5 57C174.24 57 187 44.2401 187 28.5C187 12.7599 174.24 0 158.5 0C142.76 0 130 12.7599 130 28.5C130 44.2401 142.76 57 158.5 57Z'
                fill='var(--indigo-400)'
            />
            <path
                d='M158.5 36V13M158.5 13L149 22.8305M158.5 13L168 22.8305'
                stroke='var(--center-channel-bg)'
                strokeLinecap='round'
            />
            <path
                d='M146 33V42H171V33'
                stroke='var(--center-channel-bg)'
                strokeLinecap='round'
            />
            <rect
                x='62'
                y='34'
                width='67'
                height='82'
                rx='2'
                fill='var(--neutral-1200'
                fillOpacity='0.24'
            />
            <rect
                x='55'
                y='21'
                width='70.3182'
                height='91'
                rx='2'
                fill='var(--center-channel-bg)'
            />
            <rect
                x='55.5'
                y='21.5'
                width='69.3182'
                height='90'
                rx='1.5'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.8'
            />
            <path
                d='M65 30H77'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.48'
                strokeLinecap='round'
            />
            <path
                d='M64 76H97'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.48'
                strokeLinecap='round'
            />
            <path
                d='M64 94H103'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.48'
                strokeLinecap='round'
            />
            <path
                d='M65 35H87'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.48'
                strokeLinecap='round'
            />
            <path
                d='M64 82H115'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.48'
                strokeLinecap='round'
            />
            <path
                d='M64 100H115'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.48'
                strokeLinecap='round'
            />
            <path
                d='M65 41H74'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.48'
                strokeLinecap='round'
            />
            <path
                d='M64 88H83'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.48'
                strokeLinecap='round'
            />
            <path
                d='M76 41H85'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.48'
                strokeLinecap='round'
            />
            <path
                d='M88 88H100'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.48'
                strokeLinecap='round'
            />
        </g>
        <defs>
            <clipPath id='clip0_4441_159184'>
                <rect
                    width='189'
                    height='116'
                    fill='var(--center-channel-bg)'
                />
            </clipPath>
        </defs>
    </svg>
);

export default ComplianceExportSVG;
